import React, { createContext, useContext, useState } from "react";

// Create context
const PrivilegeContext = createContext();

// Provider
export const PrivilegeProvider = ({ children }) => {
  // Initialize state from localStorage
  const [privileges, setPrivilegesState] = useState(() => {
    const stored = localStorage.getItem("privileges");
    return stored ? JSON.parse(stored) : [];
  });

  // Update state and localStorage together
  const setPrivileges = (newPrivileges) => {
    setPrivilegesState(newPrivileges);
    localStorage.setItem("privileges", JSON.stringify(newPrivileges));
  };

  return (
    <PrivilegeContext.Provider value={{ privileges, setPrivileges }}>
      {children}
    </PrivilegeContext.Provider>
  );
};

// Custom hook
export const usePrivileges = () => useContext(PrivilegeContext);

export default PrivilegeContext;
